<template>
  <div class="about">
    <div class="header">
      <div class="header-body">
        <div class="header-body-title">绽放工场</div>
        <div class="header-body-line"></div>
        <div class="header-body-desc"> 不断攀登，只为更优秀的明天 </div>
      </div>
      <figure class="bg"></figure>
    </div>
    <div class="body">
      <img class="body-poster" src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_h438px_content1%402x.png" />
      <img class="body-poster" src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_h680px_content2%402x.png" />

      <div class="list">
        <img class="list-title" src="../../static/images/we_certificate_title@2x.png">
        <swiper class="banner" :options="swiperOption">
          <swiper-slide class="swiper-img">
            <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_certificate_1%402x.png" />
          </swiper-slide>
          <swiper-slide class="swiper-img">
            <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_certificate_2%402x.png" />
          </swiper-slide>
          <swiper-slide class="swiper-img">
            <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_certificate_3%402x.png" />
          </swiper-slide>
          <swiper-slide class="swiper-img">
            <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_certificate_4%402x.png" />
          </swiper-slide>
          <swiper-slide class="swiper-img">
            <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_certificate_5%402x.png" />
          </swiper-slide>
          <swiper-slide class="swiper-img">
            <img src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_certificate_6%402x.png" />
          </swiper-slide>
        </swiper>
      </div>
      
      <img class="body-poster" src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_h822px_contact_background%402x.png" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        slidesPerView : 4,
        spaceBetween: 40,
        grabCursor: true,
        autoplay: {
          delay: 1500,
          disableOnInteraction: true
        },
        loop: true,
      }
    }
  }
}
</script>
<style scoped>
.header {
  text-align: center;
  color: #ffffff;
  height: 560px;
  overflow: hidden;
  position: relative;
}
.header-body {
  max-width: 1200px;
  margin: 230px auto 0;
}
.header-body-title {
  font-size:40px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
}
.header-body-line {
  width:40px;
  height:1px;
  background:rgba(255,255,255,1);
  margin: 22px auto 30px;
}
.header-body-desc {
  font-size:18px;
  color:rgba(255,255,255,1);
}
.bg {
  width: 1920px;
  height: 560px;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/we_h560px_banner%402x.png');
  background-size: 1920px 560px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.body {
  background-color: #F7FCFC;
  overflow: hidden;
}
.body-poster {
  width: 1920px;
  position: relative;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  display: block;
}
.list {
  padding: 90px 0;
}
.list-title {
  width: 282px;
  margin: auto;
  display: block;
  margin-bottom: 60px;
}
.banner {
  height: 420px;
  max-width: 1200px;
}
.imgs {
  font-size: 0;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.banner img{
  line-height: 0;
  font-size: 0;
  width: 260px;
  font-size: 0;
  box-shadow:0px 2px 12px 0px rgba(80,80,80,0.24);  
}
.swiper-img {
  width: 260px;
  height: 370px;
}
.swiper-img img {
  width: 100%;
  height: 100%;
}
.hidden {
  opacity: 0;
}

.about >>> .swiper-pagination-bullet {
  width:32px;
  height:8px;
  background: #FF574E;
  opacity: .3;
  border-radius: 0;
}
.about >>> .swiper-pagination-bullet-active {
  opacity: 1;
  width:32px;
  height:8px;
  background: #FF574E;
}

@media (max-width: 1199px) and (min-width: 992px){
  .body-poster {
    width: calc(1920px * 0.82);
  }
  .list-title {
    width: calc(282px * 0.82);
    margin-bottom: 40px;
  }
  .list {
    padding: 60px 0;
  }
  .banner {
    height: 380px;
    padding: 0 20px;
  }
  .banner img{
    width: calc(260px * 0.82);
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .body-poster {
    width: calc(1920px * 0.70);
  }
  .list-title {
    width: calc(282px * 0.70);
    margin-bottom: 20px;
  }
  .list {
    padding: 40px 0;
  }
  .banner {
    height: 350px;
  }
  .banner img{
    width: calc(260px * 0.70);
  }
}
@media screen and (max-width: 767px){
  .body-poster {
    width: calc(1920px * 0.60);
  }
  .list-title {
    width: calc(282px * 0.60);
    margin-bottom: 0;
  }
  .list {
    padding: 30px 0;
  }
  .banner {
    height: 300px;
  }
  .banner img{
    width: calc(260px * 0.60);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/about.vue